export enum CentralHotDeliveryEnum {
  HotWaterDeliveryYes = 'hotwaterdeliverycentral_yes',
  HotWaterDeliveryNo = 'hotwaterdeliverycentral_no'
}

export enum HeatingCostsInvoiceEnum {
  None = 'none',
  Personal = 'personal',
  ProfessionalOther = 'professional_other'
}

export enum HeatingTypeEnum {
  Radiator = 'radiator',
  UnderFloorHeating = 'underfloor_heating',
  RadiatorAndUnderFloorHeating = 'radiator_underfloor_heating'
}

export type CentralHotWaterDelivery =
  | CentralHotDeliveryEnum.HotWaterDeliveryYes
  | CentralHotDeliveryEnum.HotWaterDeliveryNo
  | '';

export type HeatingCostsInvoice =
  | HeatingCostsInvoiceEnum.None
  | HeatingCostsInvoiceEnum.Personal
  | HeatingCostsInvoiceEnum.ProfessionalOther
  | '';

export type HeatingType =
  | HeatingTypeEnum.Radiator
  | HeatingTypeEnum.UnderFloorHeating
  | HeatingTypeEnum.RadiatorAndUnderFloorHeating
  | '';

export interface MarketingConsent {
  consentGiven: boolean;
  consentVersion: string;
  consentSubmittedToMarketo?: Date;
}

export interface GivenConsent {
  type: string;
  version: string;
  dateSigned: string;
}

export interface ProductService {
  name: string;
  price: number;
  currency: string;
  appliedDiscount?: number;
}

export type StoreObject = {
  numberOfApartments?: number;
  heatingCostsInvoice: HeatingCostsInvoice;
  centralHeatingAvailable: string;
  centralHotWaterDelivery: CentralHotWaterDelivery;
  heatingType: HeatingType;
  heatingSources: string[];
  contactDetails: {
    gender: string;
    fname: string;
    lname: string;
    phone: string;
    email: string;
  };
  invoiceAddress: {
    street: string;
    houseNumber: string;
    zip: string;
    city: string;
  };
  houseAddress: {
    street: string;
    houseNumber: string;
    zip: string;
    city: string;
  };
  billingPeriod: {
    startDate?: string;
    endDate?: string;
  };
  givenConsents: GivenConsent[];
  marketingConsent: MarketingConsent;
  products: ProductService[];
  reducedProducts: ProductService[];
  selectedProducts: ProductService[];
};
